import React from "react";
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent, AlertDialogFooter, AlertDialogHeader,
    AlertDialogOverlay,
    Box, Button,
    SimpleGrid
} from "@chakra-ui/react";
import { useNewUser } from "./hooks/useNewUser";
// import NewUserTable from "./components/Table";
import NewUserTable from "./components/DataTable";
import NewUserForm from "./components/Form";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const NewUserScreen = () => {

    const {
        state,
        cancelRef,
        add,
        closeDelete,
        closeError,
        changeInput,
        changeContactInput,
        changeAddressInput,
        changeInputPermission,
        showModal,
        saveUser,
        deleteUser,
        editUser,
        displayInputError,
    } = useNewUser();

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <ConditionalRenderer
                conditions={[
                    {
                        condition: state.show,
                        component: (
                            <SimpleConditionalFrame
                                backClick={() => showModal(false)}
                                title={state.user.id
                                    ? "Editar Usuário"
                                    : "Novo Usuário"}
                            >
                                <NewUserForm
                                    state={state}
                                    showModal={showModal}
                                    changeInput={changeInput}
                                    changeAddressInput={changeAddressInput}
                                    changeContactInput={changeContactInput}
                                    changeInputPermission={changeInputPermission}
                                    saveUser={saveUser}
                                    displayInputError={displayInputError}
                                />
                            </SimpleConditionalFrame>
                        )
                    }
                ]}
                fallback={(
                    <SimpleGrid
                        mb="20px"
                        columns={{ sm: 1, md: 1 }}
                        spacing={{ base: "20px", xl: "20px" }}
                    >
                        <NewUserTable
                            state={state}
                            cancelRef={cancelRef}
                            add={add}
                            closeDelete={closeDelete}
                            editUser={editUser}
                            deleteUser={deleteUser}
                        />
                    </SimpleGrid>
                )}
            />

            <AlertDialog
                isOpen={state.error}
                leastDestructiveRef={cancelRef}
                onClose={closeError}
                isCentered
                motionPreset="slideInBottom"
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            {state.errorTitle}
                        </AlertDialogHeader>

                        <AlertDialogBody>{state.errorMsg}</AlertDialogBody>

                        <AlertDialogFooter>
                            <Button
                                ref={cancelRef}
                                onClick={closeError}
                                colorScheme={"blue"}
                            >
                                OK
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>
    );
}

export default NewUserScreen;
